import * as React from "react";
import { viewDate } from "src/common/formats";
import { isPl2RowComplete, ZPlanning2Row } from "../ZPlanning2Row";
import { Planning2Column } from "./Planning2Table/Planning2Column";

export const buildPlanning2Columns = (params: {
  onTask: (task: ZPlanning2Row) => void;
}): Planning2Column[] => [
  {
    key: "name",
    title: "Группа задач / задача",
    width: 430,
    render: (_, row) =>
      row.kind === "task" ? (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            params.onTask(row);
          }}
        >
          {row.name}
        </a>
      ) : (
        <b>
          {row.name}: {row.children.length}
        </b>
      ),
  },
  {
    key: "state",
    title: "Состояние",
    render: (_, row) => (row.kind === "task" ? row.stateName : null),
    width: 130,
  },
  {
    key: "priority",
    title: "Приоритет",
    render: (_, row) => (row.kind === "task" ? row.priorityLabel : null),
    width: 110,
  },
  {
    key: "department",
    title: "Департамент",
    render: (_, row) => (row.kind === "task" ? row.departmentLabel : null),
    width: 170,
  },
  {
    key: "employee",
    title: "Исполнитель",
    render: (_, row) => (row.kind === "task" ? row.employeeLabel : null),
    width: 170,
  },
  {
    key: "duration",
    title: "Длительность",
    render: (_, row) => (row.kind === "task" ? row.duration : null),
    width: 130,
  },
  {
    key: "durationEstimation",
    title: "Оценка длительности",
    render: (_, row) => (row.kind === "task" ? row.durationEstimation : null),
    width: 130,
  },
  {
    key: "plannedStartDate",
    title: "План. начало",
    render: (_, row) => viewDate(row.plannedStartDate),
    width: 160,
  },
  {
    key: "plannedEndDate",
    title: "План. окончание",
    render: (_, row) => viewDate(row.plannedEndDate),
    width: 160,
  },
  {
    key: "actualStartDate",
    title: "Факт. начало",
    render: (_, row) => viewDate(row.actualStartDate),
    width: 160,
  },
  {
    key: "actualEndDate",
    title: "Факт. окончание",
    render: (_, row) => viewDate(row.actualEndDate),
    width: 160,
  },
  {
    key: "forecastStartDate",
    title: "Прогноз. начало",
    render: (_, row) => {
      if (isPl2RowComplete(row)) return "-";
      return row.kind === "task" ? viewDate(row.forecastStartDate) : null;
    },
    width: 160,
  },
  {
    key: "forecastEndDate",
    title: "Прогноз. окончание",
    render: (_, row) => {
      if (isPl2RowComplete(row)) return "-";
      return row.kind === "task" ? viewDate(row.forecastEndDate) : null;
    },
    width: 160,
  },
  {
    key: "delay",
    title: "Отклонение",
    render: (_, row) => (row.kind === "task" ? row.delay : null),
    width: 100,
  },
];
